import { GatePass } from './../../_models/gate_pass';
import { User } from './../../_models/user';



import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Guardian } from 'src/app/_models/guardian';
import { ResultData } from 'src/app/_models/ResultData';
import { Student } from 'src/app/_models/student';
import { AuthService } from '../../_services/auth.service';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SignInComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  errorMessage = '';
  isLoginPassed = true
  roles: string[] = []
  guardian = new Guardian()
  student = new Student()
  gatePass:GatePass = new GatePass()
  user:User=new User()
  icons: string[] = []

  constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private authService: AuthService

  ) {

  }
  get f() { return this.form.controls; }
  ngOnInit() {
    for(let i=1;i<=11;i++){
      this.icons.push("assets/images/icons/math-fun/icon-"+i+".svg")
    }
    this.fetchGatePass()
    if (this.gatePass.is_logged_in) {
        let hLink:any=this.authService.getHomeRoute(this.gatePass)
        this.router.navigate(hLink);
      }else{
        this.initializeForm()
      }
  }
  initializeForm(){
    this.form = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'), Validators.minLength(1)])],
      password: ['', Validators.compose([Validators.required,Validators.minLength(5)])]
  });

  if (this.authService.getToken()) {
    this.roles = this.authService.getUser().roles;
  }
  }




  onSubmit(): void {
    this.authService.login(this.f.username.value, this.f.password.value).subscribe({
      next: (user) => {
        this.loading=true
        let accessToken=user.access_token;
        this.authService.saveToken(accessToken);

        if(accessToken){
          if(!user.id){
            this.authService.getAuthenticatedUserId(accessToken).subscribe({
              next:(data:ResultData)=>{
                user.id = data.rs.data.id
                this.storeUserInfo(user)
                this.navigateToHome()
              }
            }
            )
          }else{
            this.storeUserInfo(user)
            this.navigateToHome()
          }

        }
      },
      error: (error) => {
        console.error('Login error:', error);
      }
    });
  }

  navigateToHome(){
    let homePath = this.authService.getHomeRoute(this.gatePass)
    this.router.navigate(homePath)
  }

  storeUserInfo(user:any){

    this.authService.saveUser(user);
    this.user=user
    this.roles = user.roles

    this.authService.publishGatePass(user)
    this.gatePass = this.authService.gatePass.getValue()

    if(!this.gatePass.is_logged_in){
      user = new User()
      this.isLoginPassed=false
    }
    this.authService.userSubject.next(new User());

    this.loading = false

  }
  fetchGatePass(){
    this.authService.myGatePass().subscribe(
      dataData=>{
        this.gatePass=dataData

      }
    )
  }


}
